/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AsyncSessionResponse } from '../../models/async-session-response';
import { BodyUpdateAsyncSession } from '../../models/body-update-async-session';

export interface UpdateAsyncSession$Params {
  session_id: string;
      body: BodyUpdateAsyncSession
}

export function updateAsyncSession(http: HttpClient, rootUrl: string, params: UpdateAsyncSession$Params, context?: HttpContext): Observable<StrictHttpResponse<AsyncSessionResponse>> {
  const rb = new RequestBuilder(rootUrl, updateAsyncSession.PATH, 'put');
  if (params) {
    rb.path('session_id', params.session_id, {});
    rb.body(params.body, 'multipart/form-data');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<AsyncSessionResponse>;
    })
  );
}

updateAsyncSession.PATH = '/sessions/{session_id}/async';
